import { put } from 'typed-redux-saga';

import { toggleMuteAction } from '../../../../../pages/call/features/device/slice';
import { countMetrika } from '../../../../helpers/metrika';

export function* dtmfToggleMuteAudioSaga() {
    countMetrika('dtmf', 'toggle-mute', 'audio');
    yield* put(toggleMuteAction({ type: 'audio', isTemporarily: true }));
}

export function* dtmfToggleMuteAudioSecondarySaga() {
    countMetrika('dtmf', 'toggle-mute', 'audio-secondary');
    yield* put(toggleMuteAction({ type: 'audio', isTemporarily: true }));
}
